// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"dab16646","255":"7ffac7a7","368":"12092e3d","382":"fe92ec6c","420":"eeb2cbe5","486":"e8a38b9d","557":"b9fe4fdc","562":"1639e8ac","715":"225d7f4a","729":"47c7f90a","745":"e9283a47","973":"df52925d","984":"8a3271d8"}[chunkId] + ".chunk.js";
};